import { useSimpleRegistrationContext } from "pages/SimpleRegistrationsPage";
import { maskName, maskBirthday, maskPhoneNumber } from "utils/maskString";
import { Box as MuiBox, styled } from "@mui/material";
import { CustomerType } from "~/type/customer";

const Box = styled(MuiBox)`
  &.customer-list {
    border: solid 1px #dee2ec;
    background: #f3f8ff;
    border-radius: 4px;
    padding: 2%;
    font-size: 3vw;
    display: flex;
    gap: 3%;
    align-items: center;
    font-weight: bold;
    margin: 3% 0;
    display: flex;

    .customer-name {
      width: 25%;
      min-width: 120px;
    }
  }

  &.customer-list-landscape {
    height: 10vh;
    gap: 8vw;
  }

  &.customer-list-portrait {
    height: 8vh;
    gap: 8vw;
  }
`;

interface CustomerListProps {
  customer: CustomerType;
}

export const CustomerList = ({ customer }: CustomerListProps) => {
  const { isLandscape } = useSimpleRegistrationContext();

  const layoutMode = isLandscape ? "landscape" : "portrait";

  return (
    <Box className={`customer-list customer-list-${layoutMode}`}>
      <Box className="customer-name">{maskName(customer.name ?? "")}</Box>
      <Box>{customer.sex === "female" ? "여" : "남"}</Box>
      {customer.birthday && <Box>{maskBirthday(customer.birthday)}</Box>}
      {customer.phoneNumber && (
        <Box>{maskPhoneNumber(customer.phoneNumber)}</Box>
      )}
    </Box>
  );
};
